module.exports = __webpack_public_path__ + "static/media/silviaFazio.ddaf8c00.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/silviaFazio.jpg
// module id = 1590
// module chunks = 1